<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('document_watch_list')"
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>
    </div>

    <app-table :options="options" :id="tableId" @action="getListAction" />

    <app-delete-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="demo-delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />
  </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../Config/ApiUrl";
import { TableHelpers } from "../../Demo/Tables/mixins/TableHelpers";
import AppFunction from "../../../../../core/helpers/app/AppFunction";
import { axiosGet} from "../../../../Helpers/AxiosHelper.js";
import { formatDate } from '@fullcalendar/common';

export default {
  extends: CoreLibrary,
  name: "DatatableWithFilter",
  mixins: [TableHelpers],
  data() {
    return {
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: "",
      rowData: {},
      tableId: "advance-table",
      options: {
        name: "AdvanceTable",
        url: actions.DOCUMENT_WATCH_LIST,
        showHeader: true,
        columns: [
          // {
          //     title: this.$t('date'),
          //     type: 'media-object',
          //     key: 'media-object',
          //     mediaTitleKey: 'name',
          //     mediaSubtitleKey: 'email',
          //     default: AppFunction.getAppUrl('images/avatar-demo.jpg'),
          //     modifier: (value, row) => {
          //         return value; // imag url
          //     },
          //     isVisible: true
          // },
          {
            title: this.$t("document_name"),
            type: "custom-html",
            key: "name",
            modifier: (value) => {
             return `<span>${this.$t(value)}</span>`;
            },
          },
          
          {
            title: this.$t("user_name"),
            type: "custom-html",
            key: "user",
            modifier: (value) => {
              return `<span>${this.$t(value && value.full_name)}</span>`;
            },
          },
          {
            title: this.$t("company_name"),
            type: "custom-html",
            key: "user",
            modifier: (value) => {
              return `<span>${this.$t(value && value.company.company_name)}</span>`;
            },
          },
          {
            title: this.$t("expiry_date"),
            type: "custom-html",
            key: "expiry_date",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("expiry_status"),
            type: "custom-html",
            key: "expiry_date",
            modifier: (value) => {
              const date1 = new Date(value);
              const date2 = new Date();
              // One day in milliseconds
              const oneDay = 1000 * 60 * 60 * 24;
              // Calculating the time difference between two dates
              const diffInTime = date1.getTime() - date2.getTime();
              // Calculating the no. of days between two dates
              const diffInDays = Math.round(diffInTime / oneDay);
              
              if (diffInDays <= 20 && diffInDays >= 11) {
                return `<span class="badge badge-sm badge-pill badge-warning">${this.$t(
                diffInDays+' Days left'
              )}</span>`;
                
              }
              else if(diffInDays <= 10) {
                if (diffInDays < 1) {
                  return `<span class="badge badge-sm badge-pill badge-danger">${this.$t(
                    'Document Expired'
                  )}</span>`;
                }
                else {
                  return `<span class="badge badge-sm badge-pill badge-danger">${this.$t(
                    diffInDays+' Days left'
                  )}</span>`;
                }
                
              }
              else {
                return `<span class="badge badge-sm badge-pill badge-success">${this.$t(
                diffInDays+' Days left'
              )}</span>`;
              }
              
            },
          },
          {
            title: this.$t("file"),
            type: "custom-html",
            key: "file",
            modifier: (value) => {
              let content = '---';
              if (value) {
                content = `<a href="${value.full_url}" download>${this.$t(value.name)}</a>`;
              }
              return `<span>${content}</span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("send_reminder"),
            icon: "mail",
            type: "none",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "none",
            component: "app-confirmation-modal",
            modalId: "demo-delete",
          },
        ],
        filters: [
        //   {
        //     title: this.$t("date"),
        //     type: "range-picker",
        //     key: "date",
        //     option: ["today", "thisMonth", "last7Days", "nextYear"],
        //   },
          // {
          //     "title": this.$t('age'),
          //     "type": "range-filter",
          //     "key": "age-range",
          //     "maxTitle": this.$t('max_age'),
          //     "minTitle": this.$t('min_age'),
          //     "sign": ""
          // },
        //   {
        //     title: this.$t("status"),
        //     type: "checkbox",
        //     key: "status",
        //     option: [
        //       { id: "active", value: "Active" },
        //       { id: "inactive", value: "Inactive" },
        //       // {id: 'invited', value: 'Invited'},
        //     ],
        //   },
        //   {
        //     title: this.$t("role"),
        //     type: "radio",
        //     key: "roles",
        //     option: [
        //       { id: "buyer", value: "Buyer" },
        //       { id: "supplier", value: "Supplier" },
        //     ],
        //     header: {
        //       title: this.$t("want_to_filter_your_list"),
        //       description: this.$t(
        //         "you_can_filter_your_data_table_which_are_created_based_on_gender"
        //       ),
        //     },
        //   },
          {
            title: this.$t("search_and_select_by_company_name"),
            type: "drop-down-filter",
            key: "search select",
            option: [],
          },
        ],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    this.searchAndSelectFilterOptions();
  },
  methods: {
    /**
     * for open add edit modal
     */
    createMember() {
      window.location = "/admin/membership/create";
    },
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    /**
     * for close add edit modal
     */
    closeAddEditModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isAddEditModalActive = false;
      this.searchAndSelectFilterOptions();
      this.reSetData();
    },

    /**
     * $emit Form datatable action
     */
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      if (actionObj.title == "Delete") {
        this.openDeleteModal();
      } else if (actionObj.title == this.$t("send_reminder")) {
          this.sendMail(rowData.id);
        
      } else if (actionObj.title == this.$t("edit")) {
        this.selectedUrl = `${actions.MEMBERSHIP}/${rowData.id}`;
        this.openAddEditModal();
      }
    },

    sendMail(id) {
      this.preloader = true;
      axiosGet(actions.DOCUMENT_EXPIRY_MAIL + "/" + id)
        .then((response) => {
          
          this.job = response.data;
          this.$toastr.s(response.data.message);
          //   this.titleinvoice = response.data.company_name;
        })
        .catch((error) => {
          this.$toastr.s(error.message);
        })
        .finally(() => {
          this.preloader = false;
        });
    },

    /**
     * for open confirmation modal
     */
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    /**
     * confirmed $emit Form confirmation modal
     */
     confirmed() {
      let url = `${actions.MYDOCUMENT_DELETE}/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#demo-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(response.data.message);
        })
        .catch(({ error }) => {
          //trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    /**
     * cancelled $emit Form confirmation modal
     */
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },

    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
    searchAndSelectFilterOptions() {
      this.axiosGet(actions.MEMBER_SEARCH_SELECT_COMPANY_NAME).then((response) => {
        let name = this.options.filters.find(
          (element) => element.title === this.$t("search_and_select_by_company_name")
        );

        name.option = response.data.map((name) => {
          return {
            id: name.value,
            value: name.value,
          };
        });
      });
    },
  },
};
</script>
